module.exports = __webpack_public_path__ + "catalog/items/heating_Electrical/Freezer/Freezer.svg";